import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconQuotaImport = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "-6 -6 79 93",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 72.5h45.5V18",
			stroke: "#4d4540",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 17,
			width: 11,
			height: 56,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 18,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 31,
			y: 18,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 46,
			y: 18,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 27,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 31,
			y: 27,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 46,
			y: 27,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 36,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 31,
			y: 36,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 46,
			y: 36,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 45,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 54,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 63,
			width: 11,
			height: 5,
			rx: 1,
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 62,
			y: 1,
			width: 12,
			height: 61,
			rx: 1,
			transform: "rotate(90 62 1)",
			stroke: "#4d4540",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 48.5,
			cy: 62.5,
			r: 18.5,
			fill: "#fff"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M59.523 62.5a11.023 11.023 0 1 0-22.046 0 11.023 11.023 0 0 0 22.046 0m-24.59 0a13.567 13.567 0 1 1 27.134 0 13.567 13.567 0 0 1-27.134 0M48.5 67.588a5.087 5.087 0 1 0 0-10.175 5.087 5.087 0 0 0 0 10.175m0-12.72a7.631 7.631 0 1 1 0 15.263 7.631 7.631 0 0 1 0-15.262M46.804 62.5a1.696 1.696 0 1 1 3.392 0 1.696 1.696 0 0 1-3.392 0",
			fill: "#fe7933"
		})
	]
});
export default SvgIconQuotaImport;
